
import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import CookieBanner from '../../components/feature/CookieBanner';

export default function PrivacyPage() {
  const { i18n } = useTranslation();

  const getTitle = () => {
    if (i18n.language === 'de') return 'Datenschutzerklärung';
    if (i18n.language === 'es') return 'Política de Privacidad';
    return 'Privacy Policy';
  };

  const getContent = () => {
    if (i18n.language === 'es') {
      return {
        intro: 'Última actualización: Enero 2026',
        controller: {
          title: 'Responsable del Tratamiento',
          text: 'El responsable del tratamiento de datos en este sitio web es:'
        },
        hosting: {
          title: 'Alojamiento y Registros del Servidor',
          text: 'Este sitio web está alojado por un proveedor de servicios externo. Los datos personales recopilados en este sitio web se almacenan en los servidores del proveedor de alojamiento. Esto puede incluir principalmente direcciones IP, solicitudes de contacto, metadatos y comunicaciones, datos de contrato, datos de contacto, nombres, accesos a páginas web y otros datos generados a través de un sitio web.',
          purpose: 'El proveedor de alojamiento se utiliza con el propósito de cumplir el contrato con nuestros clientes potenciales y existentes (Art. 6 párr. 1 lit. b RGPD) y en interés de una provisión segura, rápida y eficiente de nuestra oferta en línea por un proveedor profesional (Art. 6 párr. 1 lit. f RGPD).'
        },
        contact: {
          title: 'Contacto por Correo Electrónico',
          text: 'Si nos contacta por correo electrónico, su consulta, incluyendo todos los datos personales resultantes (nombre, consulta), será almacenada y procesada por nosotros con el propósito de procesar su solicitud. No transmitimos estos datos sin su consentimiento.',
          legal: 'El procesamiento de estos datos se basa en el Art. 6 párr. 1 lit. b RGPD si su solicitud está relacionada con el cumplimiento de un contrato o es necesaria para llevar a cabo medidas precontractuales. En todos los demás casos, el procesamiento se basa en nuestro interés legítimo en el procesamiento efectivo de las consultas dirigidas a nosotros (Art. 6 párr. 1 lit. f RGPD) o en su consentimiento (Art. 6 párr. 1 lit. a RGPD) si esto ha sido solicitado.',
          retention: 'Los datos que nos envía a través de solicitudes de contacto permanecen con nosotros hasta que nos solicite eliminarlos, revoque su consentimiento para el almacenamiento, o el propósito del almacenamiento de datos deje de aplicarse (por ejemplo, después de completar el procesamiento de su solicitud). Las disposiciones legales obligatorias, especialmente los períodos de retención legal, permanecen inalteradas.'
        },
        cookies: {
          title: 'Gestión del Consentimiento de Cookies',
          text: 'Este sitio web utiliza una función de gestión del consentimiento de cookies para obtener y gestionar su consentimiento para el uso de cookies. Su configuración de consentimiento se almacena localmente en su navegador.',
          change: 'Puede cambiar o revocar su consentimiento en cualquier momento visitando nuestra',
          link: 'página de configuración de cookies'
        },
        processors: {
          title: 'Procesadores',
          text: 'Podemos utilizar procesadores externos para procesar sus datos. Estos procesadores han sido cuidadosamente seleccionados y están obligados por nosotros, están sujetos a nuestras instrucciones y son auditados regularmente.'
        },
        transfer: {
          title: 'Transferencias a Terceros Países',
          text: 'Actualmente no transferimos datos personales a países fuera del Espacio Económico Europeo (EEE). Si esto cambia en el futuro, le informaremos en consecuencia y garantizaremos que se implementen las salvaguardias apropiadas.'
        },
        rights: {
          title: 'Sus Derechos',
          intro: 'Tiene los siguientes derechos con respecto a sus datos personales:',
          list: [
            'Derecho de acceso (Art. 15 RGPD)',
            'Derecho de rectificación (Art. 16 RGPD)',
            'Derecho de supresión (Art. 17 RGPD)',
            'Derecho a la limitación del tratamiento (Art. 18 RGPD)',
            'Derecho a la portabilidad de los datos (Art. 20 RGPD)',
            'Derecho de oposición (Art. 21 RGPD)',
            'Derecho a retirar el consentimiento (Art. 7 párr. 3 RGPD)'
          ]
        },
        complaint: {
          title: 'Derecho a Presentar una Reclamación',
          text: 'Tiene derecho a presentar una reclamación ante una autoridad de control, en particular en el Estado miembro de su residencia habitual, lugar de trabajo o lugar de la presunta infracción si considera que el procesamiento de datos personales que le conciernen infringe el RGPD.'
        }
      };
    }

    if (i18n.language === 'de') {
      return {
        intro: 'Stand: Januar 2026',
        controller: {
          title: 'Verantwortlicher',
          text: 'Verantwortlicher für die Datenverarbeitung auf dieser Website ist:'
        },
        hosting: {
          title: 'Hosting und Server-Logs',
          text: 'Diese Website wird von einem externen Dienstleister gehostet. Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert. Hierbei kann es sich v. a. um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe und sonstige Daten, die über eine Website generiert werden, handeln.',
          purpose: 'Der Einsatz des Hosters erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren potenziellen und bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen und effizienten Bereitstellung unseres Online-Angebots durch einen professionellen Anbieter (Art. 6 Abs. 1 lit. f DSGVO).'
        },
        contact: {
          title: 'Kontaktaufnahme per E-Mail',
          text: 'Wenn Sie uns per E-Mail kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.',
          legal: 'Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde.',
          retention: 'Die von Ihnen an uns per Kontaktanfragen übersandten Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt (z. B. nach abgeschlossener Bearbeitung Ihres Anliegens). Zwingende gesetzliche Bestimmungen – insbesondere gesetzliche Aufbewahrungsfristen – bleiben unberührt.'
        },
        cookies: {
          title: 'Cookie-Einwilligungsverwaltung',
          text: 'Diese Website verwendet eine Cookie-Einwilligungsverwaltungsfunktion, um Ihre Einwilligung zur Verwendung von Cookies einzuholen und zu verwalten. Ihre Einwilligungseinstellungen werden lokal in Ihrem Browser gespeichert.',
          change: 'Sie können Ihre Einwilligung jederzeit ändern oder widerrufen, indem Sie unsere',
          link: 'Cookie-Einstellungsseite'
        },
        processors: {
          title: 'Auftragsverarbeiter',
          text: 'Wir können externe Auftragsverarbeiter zur Verarbeitung Ihrer Daten einsetzen. Diese Auftragsverarbeiter wurden von uns sorgfältig ausgewählt und sind uns gegenüber weisungsgebunden, unterliegen unseren Weisungen und werden regelmäßig überprüft.'
        },
        transfer: {
          title: 'Übermittlungen in Drittländer',
          text: 'Wir übermitteln derzeit keine personenbezogenen Daten in Länder außerhalb des Europäischen Wirtschaftsraums (EWR). Sollte sich dies in Zukunft ändern, werden wir Sie entsprechend informieren und sicherstellen, dass geeignete Garantien implementiert sind.'
        },
        rights: {
          title: 'Ihre Rechte',
          intro: 'Sie haben folgende Rechte bezüglich Ihrer personenbezogenen Daten:',
          list: [
            'Recht auf Auskunft (Art. 15 DSGVO)',
            'Recht auf Berichtigung (Art. 16 DSGVO)',
            'Recht auf Löschung (Art. 17 DSGVO)',
            'Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)',
            'Recht auf Datenübertragbarkeit (Art. 20 DSGVO)',
            'Widerspruchsrecht (Art. 21 DSGVO)',
            'Recht auf Widerruf der Einwilligung (Art. 7 Abs. 3 DSGVO)'
          ]
        },
        complaint: {
          title: 'Beschwerderecht',
          text: 'Sie haben das Recht, sich bei einer Aufsichtsbehörde zu beschweren, insbesondere in dem Mitgliedstaat Ihres gewöhnlichen Aufenthaltsorts, Ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes, wenn Sie der Ansicht sind, dass die Verarbeitung der Sie betreffenden personenbezogenen Daten gegen die DSGVO verstößt.'
        }
      };
    }

    // English
    return {
      intro: 'Last updated: January 2026',
      controller: {
        title: 'Controller',
        text: 'The controller responsible for data processing on this website is:'
      },
      hosting: {
        title: 'Hosting and Server Logs',
        text: 'This website is hosted by an external service provider. Personal data collected on this website is stored on the hosting provider\'s servers. This may primarily include IP addresses, contact requests, metadata and communications, contract data, contact details, names, website accesses, and other data generated through a website.',
        purpose: 'The hosting provider is used for the purpose of fulfilling the contract with our potential and existing customers (Art. 6 para. 1 lit. b GDPR) and in the interest of a secure, fast, and efficient provision of our online offering by a professional provider (Art. 6 para. 1 lit. f GDPR).'
      },
      contact: {
        title: 'Contact via Email',
        text: 'If you contact us by email, your inquiry, including all resulting personal data (name, inquiry), will be stored and processed by us for the purpose of processing your request. We do not pass on this data without your consent.',
        legal: 'The processing of this data is based on Art. 6 para. 1 lit. b GDPR if your inquiry is related to the fulfillment of a contract or is necessary for the implementation of pre-contractual measures. In all other cases, the processing is based on our legitimate interest in the effective processing of inquiries directed to us (Art. 6 para. 1 lit. f GDPR) or on your consent (Art. 6 para. 1 lit. a GDPR) if this has been requested.',
        retention: 'The data you send to us via contact requests remains with us until you request us to delete it, revoke your consent to storage, or the purpose for data storage no longer applies (e.g., after completing the processing of your request). Mandatory legal provisions, especially statutory retention periods, remain unaffected.'
      },
      cookies: {
        title: 'Cookie Consent Management',
        text: 'This website uses a cookie consent management function to obtain and manage your consent for the use of cookies. Your consent settings are stored locally in your browser.',
        change: 'You can change or revoke your consent at any time by visiting our',
        link: 'cookie settings page'
      },
      processors: {
        title: 'Processors',
        text: 'We may use external processors to process your data. These processors have been carefully selected and are bound by us, are subject to our instructions, and are regularly audited.'
      },
      transfer: {
        title: 'Transfers to Third Countries',
        text: 'We currently do not transfer personal data to countries outside the European Economic Area (EEA). If this changes in the future, we will inform you accordingly and ensure that appropriate safeguards are implemented.'
      },
      rights: {
        title: 'Your Rights',
        intro: 'You have the following rights regarding your personal data:',
        list: [
          'Right of access (Art. 15 GDPR)',
          'Right to rectification (Art. 16 GDPR)',
          'Right to erasure (Art. 17 GDPR)',
          'Right to restriction of processing (Art. 18 GDPR)',
          'Right to data portability (Art. 20 GDPR)',
          'Right to object (Art. 21 GDPR)',
          'Right to withdraw consent (Art. 7 para. 3 GDPR)'
        ]
      },
      complaint: {
        title: 'Right to Lodge a Complaint',
        text: 'You have the right to lodge a complaint with a supervisory authority, in particular in the Member State of your habitual residence, place of work, or place of the alleged infringement if you consider that the processing of personal data relating to you infringes the GDPR.'
      }
    };
  };

  const content = getContent();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <CookieBanner />

      <section className="pt-32 pb-24">
        <div className="max-w-[800px] mx-auto px-10">
          <h1
            className="text-5xl font-bold text-[#0A2D50] mb-6"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            {getTitle()}
          </h1>
          <p className="text-sm text-gray-500 mb-12">{content.intro}</p>

          <div className="prose prose-gray max-w-none space-y-10">
            {/* Controller */}
            <div>
              <h2 className="text-2xl font-semibold text-[#0A2D50] mb-4">
                {content.controller.title}
              </h2>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                {content.controller.text}
              </p>
              <p className="text-base text-gray-700 leading-relaxed">
                DR Group GmbH<br />
                In der Gottesau 4<br />
                76646 Bruchsal<br />
                Germany<br />
                E-Mail: <a href="mailto:info@group-dr.com" className="text-[#1BCDFF] hover:text-[#1EB7EC] cursor-pointer">info@group-dr.com</a><br />
                {i18n.language === 'de' ? 'Telefon' : i18n.language === 'es' ? 'Teléfono' : 'Phone'}: <a href="tel:+491708843942" className="text-[#1BCDFF] hover:text-[#1EB7EC] cursor-pointer">+49 170 8843 942</a>
              </p>
            </div>

            {/* Hosting */}
            <div>
              <h2 className="text-2xl font-semibold text-[#0A2D50] mb-4">
                {content.hosting.title}
              </h2>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                {content.hosting.text}
              </p>
              <p className="text-base text-gray-700 leading-relaxed">
                {content.hosting.purpose}
              </p>
            </div>

            {/* Contact */}
            <div>
              <h2 className="text-2xl font-semibold text-[#0A2D50] mb-4">
                {content.contact.title}
              </h2>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                {content.contact.text}
              </p>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                {content.contact.legal}
              </p>
              <p className="text-base text-gray-700 leading-relaxed">
                {content.contact.retention}
              </p>
            </div>

            {/* Cookies */}
            <div>
              <h2 className="text-2xl font-semibold text-[#0A2D50] mb-4">
                {content.cookies.title}
              </h2>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                {content.cookies.text}
              </p>
              <p className="text-base text-gray-700 leading-relaxed">
                {content.cookies.change}{' '}
                <a href="/cookie-settings" className="text-[#1BCDFF] hover:text-[#1EB7EC] cursor-pointer">
                  {content.cookies.link}
                </a>.
              </p>
            </div>

            {/* Processors */}
            <div>
              <h2 className="text-2xl font-semibold text-[#0A2D50] mb-4">
                {content.processors.title}
              </h2>
              <p className="text-base text-gray-700 leading-relaxed">
                {content.processors.text}
              </p>
            </div>

            {/* Transfer */}
            <div>
              <h2 className="text-2xl font-semibold text-[#0A2D50] mb-4">
                {content.transfer.title}
              </h2>
              <p className="text-base text-gray-700 leading-relaxed">
                {content.transfer.text}
              </p>
            </div>

            {/* Rights */}
            <div>
              <h2 className="text-2xl font-semibold text-[#0A2D50] mb-4">
                {content.rights.title}
              </h2>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                {content.rights.intro}
              </p>
              <ul className="list-disc list-inside space-y-2 text-base text-gray-700">
                {content.rights.list.map((right, index) => (
                  <li key={index}>{right}</li>
                ))}
              </ul>
            </div>

            {/* Complaint */}
            <div>
              <h2 className="text-2xl font-semibold text-[#0A2D50] mb-4">
                {content.complaint.title}
              </h2>
              <p className="text-base text-gray-700 leading-relaxed">
                {content.complaint.text}
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
